import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { PreviousUrlService } from "src/app/services/previous-url.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-mfa",
    templateUrl: "./mfa.component.html",
    styleUrls: ["./mfa.component.scss"],
    standalone: false
})
export class MfaComponent implements OnInit {
  @Input() public title: string;
  @Input() public text: string;
  @Input() public loginForm: FormGroup;
  @Input() public username: any;
  @Input() public myUser: any;
  @Input() public id: any;
  @Input() public MFAFail: any;
  @Input() public textBtn: string;
  @Input() public errorMessageMfaNotReceiving: boolean;
  @Input() public phoneNumber: any;
  @Input() public isLogIn: string;

  @Output() submitEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendToLocationEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() disableSignInBtnEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() statusMFA: EventEmitter<any> = new EventEmitter<any>();
  @Output() updatephoneNumber: EventEmitter<any> = new EventEmitter<any>();
  @Output() switchToEmail: EventEmitter<any> = new EventEmitter<any>();

  public mfaForm: FormGroup;
  public doMFA: boolean;
  public MFAEmpty: boolean;
  public previousLink: string;
  public errorMessageMfaNotTrue: boolean;
  public mfaFailCount = 0;
  public disabled: boolean = true;
  public resendCodeDisabled: boolean;
  public intervalId: ReturnType<typeof setTimeout>;
  public counter = 60;
  public disableSignInBtn: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private api: ZpDataService,
    private previousUrl: PreviousUrlService,
    private router: Router, 
    public themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    this.previousLink = this.previousUrl.getPreviousUrl();
    this.mfaForm = this.formBuilder.group({
      mfaCode: ["", [Validators.required]],
    });
    if (this.isLogIn) {
      this.resendCodeDisabled = true;
      this.startCountdown();
    }
  }

  get isSMS() {
    console.log(this.myUser);
    if (this.myUser && this.myUser.mfaVia && this.myUser.mfaVia === "SMS") {
      return true;
    }
    return false;
  }

  async confirmMFACode() {
    console.log("confirmCode() myUser: ", this.myUser);
    const code = this.mfaForm.controls["mfaCode"].value;
    if (code) {
      const result = await this.api.confirmMFACode(code);
      if (result.success) {
        console.log('result ', result )
        this.statusMFA.emit(true);
        if (
          this.previousLink.includes("/dynamicedit/") ||
          this.previousLink.includes("/payment-choose-plan")
        ) {
          this.router.navigate(["/payment-choose-plan"]);
        } 
        // else {
        //   if (this.username) {
        //     console.log("userName: ", this.username);
        //     if (!localStorage.mstesmarker) {
        //       localStorage.mstesmarker = JSON.stringify({});
        //     }
        //     const mstesmarker = JSON.parse(localStorage.mstesmarker);
        //     mstesmarker[this.username] = code;
        //     localStorage.mstesmarker = JSON.stringify(mstesmarker);
        //   }
        // }
        this.MFAFail = false;
        this.errorMessageMfaNotTrue = false;
        this.mfaFailCount = 0;
        this.sendToLocationEvent.emit(this.myUser);
      } else {
        this.MFAFail = true;
        this.mfaFailCount++;
        console.log("mfaFailCount", this.mfaFailCount);
        if (this.mfaFailCount === 1) {
          this.errorMessageMfaNotTrue = true;
        }
        // if (this.mfaFailCount === 6) {
        //   this.disableSignInBtn = true;
        //   this.disableSignInBtnEvent.emit(this.disableSignInBtn);
        // }
      }
      // if (!this.myUser) {
      //   this.myUser = await this.api.getItemUser(this.id, "users");
      // }
      // if (this.myUser) {
      //   this.sendToLocationEvent.emit(this.myUser);
      // } else {
      //   this.submitEvent.emit();
      // }
    } else {
      this.MFAEmpty = true;
    }
    // if (this.myUser) {
    //   this.sendToLocationEvent.emit(this.myUser);
    // }
  }

  async resendMFA() {
    this.resendCodeDisabled = true;
    this.startCountdown();
    await this.api.requestMFACode();
    this.doMFA = true;
    alert("A code has been resent to your " + (this.isSMS ? "phone" : "email"));
  }

  startCountdown() {
    this.resendCodeDisabled = true;
    console.log(this.resendCodeDisabled);
    this.intervalId = setInterval(() => {
      this.counter--;

      if (this.counter <= 0) {
        this.stopCountdown();
        this.resendCodeDisabled = false;
      } else {
        this.resendCodeDisabled = true;
      }
    }, 1000);
  }

  stopCountdown() {
    clearInterval(this.intervalId);
    this.counter = 60;
  }

  switchStatus(status) {
    if (status === "updateMobile") {
      this.updatephoneNumber.emit(true);
    }
    if (status === "nosend") {
      this.myUser.mfaVia = "Email";
      this.sendToLocationEvent.emit(this.myUser);
    }
    if (status === "switchToEmail") {
      this.switchToEmail.emit(true);
    }
  }
}
